import { I18n } from '@/i18n/I18n';
import { useLocation, useNavigate } from 'react-router-dom';


export function NavigationTabButton(props: { tabName: string, routeName: string, procedureId: string }) {
  const { tabName, routeName, procedureId } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = location.pathname.includes(routeName);

  function isElementInViewport (el: Element) {
    const rect = el.getBoundingClientRect();

    return (
      rect.top >= 0 &&
      rect.top <= window.innerHeight
    );
  }

  const navigateWrapper = () => {
    let visId: string | null = null;
    document.querySelectorAll('.observed-element').forEach((element) => {
      if (isElementInViewport(element) && !visId) {
       visId = element.id;
      }
    });

    return navigate(`/procedures/${routeName}/${procedureId}#${visId}`);
  };

  return (
    <li className="nav-item">
      <div className="flex flex-column">
        <button
          className={`nav-link ${isActive ? 'active' : ''}`}
          style={{ maxWidth: 'fit-content' }}
          type="button"
          onClick={() => void navigateWrapper()}
          aria-label={I18n.get(tabName)}
          title={I18n.get(tabName)}
        >
          <p className="my-auto text-nowrap">{I18n.get(tabName)}</p>
          { isActive && <hr className='m-0' data-testid="active-underline" /> }
        </button>
      </div>
    </li>
  );
}
